import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CONSTANTS } from '../../../constants';
import { DataService } from '../../../services/data.service';
import { NotificationService } from '../../../services/notification.service';
import { ThreadService } from '../../../services/api/thread.service';

@Component({
  selector: 'strategy-lss-v1',
  templateUrl: './lss-v1.component.html',
  styleUrls: ['./lss-v1.component.scss']
})
export class LssV1Component implements OnInit, OnDestroy {

  @Input('params')
  params: any;

  admin: any
  edit: any;
  strategy: any;
  strategyParams: any;
  saveSettingsEvent: any;

  categories = [CONSTANTS.DEFAULT.CATEGORY];
  segments = [CONSTANTS.DEFAULT.SEGMENT];
  symbols = [CONSTANTS.DEFAULT.SYMBOL];
  days = CONSTANTS.DAYS;
  intervals = CONSTANTS.INTERVALS;

  constructor(private dataService: DataService, private notificationService: NotificationService,
    private threadService: ThreadService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.edit = this.params.edit;
    this.strategy = this.params.strategy;
    this.strategyParams = this.params.strategyParams;
    this.populateDatas();
    this.populateOpenStrategyModal();
    this.saveSettingsEvent = this.dataService.onSaveSettings.subscribe(data => {
      if (data.code == 'lss_v1') {
        this.saveSettings(data.params, data.data);
      }
    });
  }

  onSymbolSelected(params: any) {
    let symbol: any = this.getSymbolByName(params.trading_symbol);
    params.symbol = symbol;
    params.strike_diff = symbol.instrument.option_details.strike_diff;
    this.setSSParams(params, params.ss.type.toLowerCase())
  }

  slTgtTypeClass(params: any, type: any, name: any) {
    if (['tgt', 'combined_tgt'].indexOf(name) > -1) {
      if (params[name].type == type) {
        return { active: 1 }
      }
    } else if (['sl', 'combined_sl'].indexOf(name) > -1) {
      if (params[name].type == type) {
        return { active: 1 }
      }
    } else if (name == 'tsl') {
      if (params.tsl.type == type) {
        return { active: 1 }
      }
    }
    return { };
  }

  onSLTgtTypeSelect(params: any, type: any, name: any) {
    let texts: any = { pts: 'Points', percent: 'Percent' };
    if (['tgt', 'combined_tgt'].indexOf(name) > -1) {
      params[name].type = type;
      params[name].type_text = texts[type];
    } else if (['sl', 'combined_sl'].indexOf(name) > -1) {
      params[name].type = type;
      params[name].type_text = texts[type];
    } else if (name == 'tsl') {
      params.tsl.type = type;
      params.tsl.type_text = texts[type];
    } 
  }

  slTgtClass(params: any, name: any) {
    if (name == 'tgt') {
      let tgt_enabled: any = (params.tgt.state == 'enabled');
      let ctgt_enabled: any = (params.combined_tgt.state == 'enabled');
      if (tgt_enabled || ctgt_enabled) {
        return { 'text-primary': 1 };
      }
    } else if (name == 'sl') {
      let sl_enabled: any = (params.sl.state == 'enabled');
      let csl_enabled: any = (params.combined_sl.state == 'enabled');
      if (sl_enabled || csl_enabled) {
        return { 'text-primary': 1 };
      }
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        return { 'text-primary': 1 };
      }
    }
    return { 'text-secondary': 1 };
  }

  onSLTgtPanelClick(params: any, name: any) {
    let names: any = [];
    if (name == 'tgt') {
      let tgt_collapsed: any = (params.tgt.content == 'collapse');
      let ctgt_collapsed: any = (params.combined_tgt.content == 'collapse');
      if (tgt_collapsed) {
        params.tgt.collapsed = !params.tgt.collapsed;
      }
      if (ctgt_collapsed) {
        params.combined_tgt.collapsed = !params.combined_tgt.collapsed;
      }
      names = ['tgt', 'combined_tgt'];
    } else if (name == 'sl') {
      let sl_collapsed: any = (params.sl.content == 'collapse');
      let csl_collapsed: any = (params.combined_sl.content == 'collapse');
      if (sl_collapsed) {
        params.sl.collapsed = !params.sl.collapsed;
      }
      if (csl_collapsed) {
        params.combined_sl.collapsed = !params.combined_sl.collapsed;
      }
      names = ['sl', 'combined_sl'];
    } else if (name == 'tsl') {
      if (params.tsl.content == 'collapse') {
        params.tsl.collapsed = !params.tsl.collapsed;
      }
      names = [name];
    }
    for (let i = 0; i < names.length; i++) {
      this.updateSLTgtContent(params, names[i]);
    }
  }

  updateSLTgtContent(params: any, name: any) {
    if (['tgt', 'combined_tgt'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        params[name].content = 'collapse';
        if (params[name].type == '') {
          let tgt_texts: any = { pts: 'Points', percent: 'Percent' };
          this.strategyParams[name]['type'] = 'percent';
          this.strategyParams[name]['value'] = 10;
          this.strategyParams[name]['type_text'] = tgt_texts[this.strategyParams[name]["type"]];
        }
      } else {
        if (params[name].collapsed) {
          params[name].content = '';
        }
        if (params[name].type != '') {
          this.strategyParams[name]['type'] = '';
          this.strategyParams[name]['value'] = '';
          this.strategyParams[name]['type_text'] = "Select";
        }
      }
    } else if (['sl', 'combined_sl'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        params[name].content = 'collapse';
        if (params[name].type == '') {
          let sl_texts: any = { pts: 'Points', percent: 'Percent' };
          this.strategyParams[name]['type'] = 'percent';
          this.strategyParams[name]['value'] = 10;
          this.strategyParams[name]['type_text'] = sl_texts[this.strategyParams[name]["type"]];
        }
      } else {
        if (params[name].collapsed) {
          params[name].content = '';
        }
        if (params[name].type != '') {
          this.strategyParams[name]['type'] = '';
          this.strategyParams[name]['value'] = '';
          this.strategyParams[name]['type_text'] = "Select";
        }
        if (name == 'sl') {
          params.tsl.state = 'disabled';
          params = this.setTSLParams(params, params.tsl.state);
        }
      }
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        params.tsl.content = 'collapse';
      } else {
        if (params.tsl.collapsed) {
          params.tsl.content = '';
        }
      }
    }
  }

  onSLTgtCheckChange(params: any, event: any, name: any) {
    if (name == 'tgt') {
      params.tgt.state = event.target.checked ? 'enabled' : 'disabled';
      this.updateExitOnForSLTgt(params);
    } else if (name == 'combined_tgt') {
      params.combined_tgt.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'sl') {
      params.sl.state = event.target.checked ? 'enabled' : 'disabled';
      this.updateExitOnForSLTgt(params);
    } else if (name == 'combined_sl') {
      params.combined_sl.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'tsl') {
      params.tsl.state = event.target.checked ? 'enabled' : 'disabled';
    }
    this.updateSLTgtContent(params, name);
  }

  onTSLCTCCheckChange(params: any, event: any) {
    params.tsl.ctc = event.target.checked ? 1 : 0;
  }

  ptClass(params: any, bt_name: any) {
    if (params.pt == bt_name) {
      return { 'btn-primary': 1 }
    }
    return { 'btn-secondary': 1 }
  }

  onPTSelect(params: any, bt_name: any) {
    params.pt = bt_name;
  }

  modeClass(params: any, bt_name: any) {
    if (params.run_mode == bt_name) {
      return { 'btn-primary': 1 }
    }
    return { 'btn-secondary': 1 }
  }

  onModeSelect(params: any, bt_name: any) {
    params.run_mode = bt_name;
  }

  ttClass(params: any, bt_name: any) {
    if (params.tt == bt_name) {
      if (bt_name == 'buy') {
        return { 'btn-success': 1 }
      } else if (bt_name == 'sell') {
        return { 'btn-danger': 1 }
      }
    }
    return { 'btn-secondary': 1 }
  }

  onTTSelect(params: any, bt_name: any) {
    params.tt = bt_name;
  }

  reenterClass(params: any, bt_name: any) {
    if (bt_name == params.reenter.on) {
      return { 'active': 1 }
    } else {
      return { }
    }
  }

  onReenterStateChanged(params: any, event: any) {
    let state: any = event.target.checked ? 'enabled' : 'disabled';
    this.setReenterParams(params, state);
  }

  onReenterSelect(params: any, bt_name: any) {
    let same_selection: any = (params.reenter.on == bt_name);
    params.reenter.on = bt_name;
    if (!same_selection) {
      this.setReenterParams(params, params.reenter.state);
    }
  }

  setReenterParams(params: any, state: any) {
    params.reenter.state = state;
    let on_map: any = { both: 'Both', sl: 'SL', tgt: 'Target' }
    if (params.reenter.state == 'enabled') {
      params.reenter.on_text = on_map[params.reenter.on] || 'On';
    } else {
      params.reenter.on_text = 'On';
    }
  }

  exitOnClass(params: any, bt_name: any) {
    if (bt_name == params.exit_on.type) {
      return { 'active': 1 }
    } else {
      return { }
    }
  }

  onExitOnStateChanged(params: any, event: any) {
    let state: any = event.target.checked ? 'enabled' : 'disabled';
    this.setExitOnParams(params, state);
  }

  onExitOnSelect(params: any, bt_name: any) {
    let same_selection: any = (params.exit_on.type == bt_name);
    params.exit_on.type = bt_name;
    if (!same_selection) {
      this.setExitOnParams(params, params.exit_on.state);
    }
  }

  setExitOnParams(params: any, state: any) {
    params.exit_on.state = state;
    let on_map: any = { both: 'Both', sl: 'SL', tgt: 'Target' }
    if (params.exit_on.state == 'enabled') {
      params.exit_on.type_text = on_map[params.exit_on.type] || 'On';
    } else {
      params.exit_on.type = '';
      params.exit_on.type_text = 'On';
    }
  }

  updateExitOnForSLTgt(params: any) {
    if (params.exit_on.state == 'enabled') {
      let tgt: any = (params.tgt.state == 'enabled');
      let sl: any = (params.sl.state == 'enabled');
      if (!tgt && !sl) {
        this.setExitOnParams(params, 'disabled');
      } else if (!sl) {
        if (['sl', 'both'].indexOf(params.exit_on.type) > -1) {
          this.setExitOnParams(params, 'disabled');
        }
      } else if (!tgt) {
        if (['tgt', 'both'].indexOf(params.exit_on.type) > -1) {
          this.setExitOnParams(params, 'disabled');
        }
      }
    }
  }

  exitOnValueClass(params: any) {
    params.exit_on.valid = true;
    if (params.exit_on.state == 'enabled') {
      let type: any = params.exit_on.type || '';
      if (['both', 'sl', 'tgt'].indexOf(type.toLowerCase()) == -1) {
        params.exit_on.valid = false;
        return { 'd-block': 1 };
      }
    }
    return { 'd-block': 0 };
  }

  onSSSelect(params: any, bt_name: any) {
    let same_selection: any = (params.ss.type == bt_name);
    if (!same_selection) {
      this.setSSParams(params, bt_name);
    }
  }

  onIntervalChanged(params: any) {
    params['interval'] = this.getInterval(params.selectedIntervalId);
  }

  setSSParams(params: any, type: any) {
    params.ss = params.ss || {};
    params.ss.type = type;
    let opt_types: any = ['ce', 'pe'];
    let name: any, step: any, min: any, max: any;
    if (type == 'default') {
      name = 'ATM';
      step = `${params.strike_diff}`;
      min = `${(params.strike_diff * 50) * -1}`;
      max = `${(params.strike_diff * 50)}`;
    } else {
        name = 'Premium';
        step = '1';
        min = '1';
        max = '3000';
    }
    params.ss.name = name;
    params.ss.step = params.ss.step || {}
    params.ss.min = params.ss.min || {}
    params.ss.max = params.ss.max || {}
    for (let opt_type of opt_types) {
      params.ss.step[opt_type] = step;
      params.ss.min[opt_type] = min;
      params.ss.max[opt_type] = max;
    }
  }

  setTSLParams(params: any, state: any) {
    if (state == 'enabled') {
      let texts: any = { pts: 'Points', percent: 'Percent', '': 'On' };
      params['tsl']['type'] = params["tsl"]["type"] ? params["tsl"]["type"] : '';
      params['tsl']['type_text'] = texts[params['tsl']['type']];
      params['tsl']['content'] = "collapse";
    } else {
      params['tsl']['type'] = "";
      params['tsl']['type_text'] = 'Select';
      params['tsl']['sl'] = "";
      params['tsl']['range'] = "";
      params['tsl']['content'] = "";
    }
    return params;
  }

  ssClass(params: any, bt_name: any) {
    if (bt_name == 'default') {
      if (params.ss.type == 'default') {
        return { 'active': 1 }
      } else {
        return { }
      }
    } else {
      if (params.ss.type == 'default') {
        return { }
      } else {
        return { 'active': 1 }
      }
    }
  }

  ssValueClass(params: any, opt_type: any) {
    let val: any = params.ss.value[opt_type];
    let hasVal: any = false;
    try {
      hasVal = !!parseInt(val);
      if (params.ss.type == 'default') {
        hasVal = hasVal || (val == 0);
      } else {
        hasVal = hasVal && (val > 0) && ((val % params.ss.step[opt_type]) == 0);
      }
    } catch (e) {
      hasVal = false;
    }
    params.ss.valid = params.ss.valid || {};
    params.ss.val_err_text = params.ss.val_err_text || {};
    if (!hasVal) {
      params.ss.valid[opt_type] = false;
      params.ss.val_err_text[opt_type] = (params.ss.type == 'default') ? `${opt_type.toUpperCase()} ATM difference value` : `proper ${opt_type.toUpperCase()} premium value`;
      return { 'd-block': 1 };
    } else {
      params.ss.valid[opt_type] = (params.ss.type == 'default') ? ((params.ss.value[opt_type] % params.ss.step[opt_type]) == 0) : true;
      if (!params.ss.valid[opt_type]) {
        params.ss.val_err_text[opt_type] = (params.ss.type == 'default') ? `${opt_type.toUpperCase()} value in multiple of ${params.ss.step[opt_type]}` : '';
        return { 'd-block': 1 };
      } else {
        params.ss.val_err_text[opt_type] = '';
        return { 'd-block': 0 };
      }
    }
  }

  lotClass(params: any) {
    let lots_val = params.lots.value;
    let has_val = false;
    try {
      lots_val = parseInt(lots_val);
      has_val = true;
    } catch (e) {
    }
    if (has_val && (lots_val > 0)) {
      params.lots.valid = true;
      return { 'd-block': 0 };
    }
    params.lots.valid = false;
    return { 'd-block': 1 };
  }

  tslValueClass(params: any) {
    if (params.tsl.range && (params.tsl.range != "") && params.tsl.sl && (params.tsl.sl != "")) {
      if (params.tsl.sl > params.tsl.range) {
        params.tsl.sl_range_valid = false;
        return { 'd-block': 1 };
      }
    }
    params.tsl.sl_range_valid = true;
    return { 'd-block': 0 };
  }

  timeValueClass(params: any) {
    params.time_valid = false;
    if (params.entry_time >= params.exit_time) {
      return { 'd-block': 1 };  
    }
    params.time_valid = true;
    return { 'd-block': 0 };
  }

  slTgtErrTypeClass(params: any, name: any) {
    if (['sl', 'combined_sl'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if (!params[name].type || (params[name].type == "")) {
          params[name].type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params[name].type_valid = true;
    } else if (['tgt', 'combined_tgt'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if (!params[name].type || (params[name].type == "")) {
          params[name].type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params[name].type_valid = true;
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        if ((!params.tsl.type || (params.tsl.type == "")) && (params.tsl.ctc == 0)) {
          params.tsl.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.type_valid = true;
    }
    return { 'is-invalid': 0 };
  }

  slTgtErrValueClass(params: any, name: any) {
    if (['sl', 'combined_sl'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if ((params[name].value == "") || params[name].value <= 0) {
          params[name].value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params[name].value_valid = true;
    } else if (['tgt', 'combined_tgt'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if ((params[name].value == "") || params[name].value <= 0) {
          params[name].value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params[name].value_valid = true;
    } else if (name == 'tslv') {
      if (params.tsl.state == 'enabled') {
        if (((params.tsl.sl == "") || (params.tsl.sl <= 0)) && (params.tsl.ctc == 0)) {
          params.tsl.value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.value_valid = true;
    } else if (name == 'tslr') {
      if (params.tsl.state == 'enabled') {
        if (((params.tsl.range == "") || (params.tsl.range <= 0)) && (params.tsl.ctc == 0)) {
          params.tsl.range_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.range_valid = true;
    }
    return { 'is-invalid': 0 };
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
       return false;
    }
    return true;
  }

  showExitOnOption(params: any, option_name: any) {
    let tgt: any = (params.tgt.state == 'enabled');
    let sl: any = (params.sl.state == 'enabled');
    if (option_name == 'tgt') {
      return tgt;
    } else if (option_name == 'sl') {
      return sl;
    } else if (option_name == 'both') {
      return tgt && sl;
    }
  }

  canDisable(params: any) {
    let tgt: any = (params.tgt.state == 'enabled');
    let sl: any = (params.sl.state == 'enabled');
    return !tgt && !sl;
  }

  getInterval(interval_id: any) {
    let intervals: any = CONSTANTS.INTERVALS;
    let interval;
    for (let i = 0; i < intervals.length; i++) {
      if (intervals[i]._id == interval_id) {
        interval = intervals[i];
        break;
      }
    }
    return interval;
  }

  getIntervalId(interval: any) {
    let intervals: any = CONSTANTS.INTERVALS;
    let interval_id = -1;
    for (let i = 0; i < intervals.length; i++) {
      if (intervals[i].name == interval) {
        interval_id = intervals[i]._id;
        break;
      }
    }
    return interval_id;
  }

  getSymbolByName(trading_symbol: any) {
    let symbol;
    for (let i = 0; i < this.symbols.length; i++) {
      if (this.symbols[i].trading_symbol == trading_symbol) {
        symbol = this.symbols[i];
        break;
      }
    }
    return symbol;
  }

  populateDatas() {
    this.categories = this.dataService.getCategories();
    this.segments = this.dataService.getSegments();
    this.symbols = this.params.symbols;
  }

  populateOpenStrategyModal() {
    let original = this.strategy["original"];
    let settings = JSON.parse(JSON.stringify(original["settings"]));
    let days: any = CONSTANTS.DAYS;
    this.strategyParams['category'] = settings["category"];
    this.strategyParams['segment'] = settings["segment"]; 
    this.strategyParams['symbol'] = this.getSymbolByName(settings["symbol"]["trading_symbol"]);
    this.strategyParams['trading_symbol'] = this.strategyParams["symbol"]["trading_symbol"];
    this.strategyParams['entry_time'] = settings["entry_time"];
    this.strategyParams['exit_time'] = settings["exit_time"];
    this.strategyParams['tt'] = settings["straddle_type"];
    this.strategyParams['pt'] = settings["trade_type"];
    this.strategyParams['selectedIntervalId'] = `${settings["interval"]}`;
    this.strategyParams['strike_diff'] = settings["strike_diff"];
    this.strategyParams['ss'] = settings['strike_selection'];
    this.strategyParams['ss']['valid'] = { 'ce': true, 'pe': true };
    this.strategyParams['ss']['val_err_text'] = { 'ce': '', 'pe': '' };
    this.strategyParams['reenter'] = settings["reenter"] || { state: 'disabled', count: 0, on_text: 'On', on: '' };
    this.strategyParams['exit_on'] = settings["exit_on"] || { state: 'disabled', type_text: 'On', type: '' };
    this.setSSParams(this.strategyParams, settings['strike_selection']['type'].toLowerCase());
    this.setReenterParams(this.strategyParams, this.strategyParams['reenter']['state']);
    this.setExitOnParams(this.strategyParams, this.strategyParams['exit_on']['state']);
    this.strategyParams['lots'] = { value: settings["lots"], valid: true };
    this.strategyParams['run_mode'] = settings["run_mode"];
    if (settings.sl) {
      this.strategyParams['sl'] = settings["sl"];
      this.strategyParams['sl']['collapsed'] = true;
      if (settings["sl"]["state"] == 'disabled') {
        this.strategyParams['sl']['type'] = "";
        this.strategyParams['sl']['content'] = "";
        this.strategyParams['sl']['type_text'] = "Select";
        this.strategyParams['sl']['value'] = "";
      } else {
        let sl_texts: any = { pts: 'Points', percent: 'Percent' };
        this.strategyParams['sl']['type'] = settings["sl"]["type"] ? settings["sl"]["type"] : 'percent';
        this.strategyParams['sl']['type_text'] = settings["sl"]["type"] ? sl_texts[settings["sl"]["type"]] : sl_texts.percent;
        this.strategyParams['sl']['content'] = "collapse";
      }
    } else {
      this.strategyParams['sl']['content'] = "";
    }
    if (settings.combined_sl) {
      this.strategyParams['combined_sl'] = settings["combined_sl"];
      this.strategyParams['combined_sl']['collapsed'] = true;
      if (settings["combined_sl"]["state"] == 'disabled') {
        this.strategyParams['combined_sl']['type'] = "";
        this.strategyParams['combined_sl']['content'] = "";
        this.strategyParams['combined_sl']['type_text'] = "Select";
        this.strategyParams['combined_sl']['value'] = "";
      } else {
        let sl_texts: any = { pts: 'Points', percent: 'Percent' };
        this.strategyParams['combined_sl']['type'] = settings["combined_sl"]["type"] ? settings["combined_sl"]["type"] : 'percent';
        this.strategyParams['combined_sl']['type_text'] = settings["combined_sl"]["type"] ? sl_texts[settings["combined_sl"]["type"]] : sl_texts.percent;
        this.strategyParams['combined_sl']['content'] = "collapse";
      }
    } else {
      this.strategyParams['combined_sl'] = {};
      this.strategyParams['combined_sl']['content'] = "";
    }
    this.strategyParams['days'] = {};
    for (let i = 0; i < days.length; i++) {
      let d = days[i].toLocaleUpperCase();
      this.strategyParams['days'][d] = (settings['days'].indexOf(d) > -1);
    }
    if (settings.tsl) {
      this.strategyParams['tsl'] = settings.tsl;
      this.strategyParams['tsl']['collapsed'] = true;
      this.strategyParams = this.setTSLParams(this.strategyParams, settings.tsl.state);
    } else {
      this.strategyParams['tsl'] = { type_text: 'Select', state: 'enabled', sl: 0, value: 0 };
    }
    if (settings.tgt) {
      this.strategyParams['tgt'] = settings["tgt"];
      this.strategyParams['tgt']['collapsed'] = true;
      if (settings["tgt"]["state"] == 'disabled') {
        this.strategyParams['tgt']['type'] = "";
        this.strategyParams['tgt']['content'] = "";
        this.strategyParams['tgt']['type_text'] = "Select";
        this.strategyParams['tgt']['value'] = "";
      } else {
        let tgt_texts: any = { pts: 'Points', percent: 'Percent' };
        this.strategyParams['tgt']['type_text'] = tgt_texts[settings["tgt"]["type"]];
        this.strategyParams['tgt']['content'] = "collapse";
      }
    } else {
      this.strategyParams['tgt']['content'] = "";
    }
    if (settings.combined_tgt) {
      this.strategyParams['combined_tgt'] = settings["combined_tgt"];
      this.strategyParams['combined_tgt']['collapsed'] = true;
      if (settings["combined_tgt"]["state"] == 'disabled') {
        this.strategyParams['combined_tgt']['type'] = "";
        this.strategyParams['combined_tgt']['content'] = "";
        this.strategyParams['combined_tgt']['type_text'] = "Select";
        this.strategyParams['combined_tgt']['value'] = "";
      } else {
        let tgt_texts: any = { pts: 'Points', percent: 'Percent' };
        this.strategyParams['combined_tgt']['type_text'] = tgt_texts[settings["combined_tgt"]["type"]];
        this.strategyParams['combined_tgt']['content'] = "collapse";
      }
    } else {
      this.strategyParams['combined_tgt'] = {};
      this.strategyParams['combined_tgt']['content'] = "";
    }
  }

  saveSettings(params: any, data: any) {
    if (!this.is_strategy_params_valid()) return;
    let symbol: any = this.strategyParams.symbol.original;
    delete symbol.instrument;
    let interval: any = this.getInterval(this.strategyParams.selectedIntervalId);
    data['settings'] = {
      "category": this.strategyParams.category,
      "segment": this.strategyParams.segment,
      "symbol": symbol,
      "tgt": {
        'state': this.strategyParams.tgt.state,
        'type' : this.strategyParams.tgt.type,
        'value' : this.strategyParams.tgt.value,
      },
      "combined_tgt": {
        'state': this.strategyParams.combined_tgt.state,
        'type' : this.strategyParams.combined_tgt.type,
        'value' : this.strategyParams.combined_tgt.value,
      },
      "sl": {
        'state': this.strategyParams.sl.state,
        'type' : this.strategyParams.sl.type,
        'value' : this.strategyParams.sl.value,
      },
      "combined_sl": {
        'state': this.strategyParams.combined_sl.state,
        'type' : this.strategyParams.combined_sl.type,
        'value' : this.strategyParams.combined_sl.value,
      },
      "tsl": {
        'state': this.strategyParams.tsl.state,
        'type' : this.strategyParams.tsl.type,
        'sl' : this.strategyParams.tsl.sl,
        'range' : this.strategyParams.tsl.range,
        'ctc': this.strategyParams.tsl.ctc
      },
      "reenter": {
        'state': this.strategyParams.reenter.state,
        'on' : this.strategyParams.reenter.on,
        'count' : this.strategyParams.reenter.count
      },
      "exit_on": {
        'state': this.strategyParams.exit_on.state,
        'type' : this.strategyParams.exit_on.type
      },
      "strike_selection": {
        'type': this.strategyParams.ss.type,
        'value' : this.strategyParams.ss.value
      },
      'lots': this.strategyParams.lots.value,
      'run_mode': this.strategyParams.run_mode,
      'trade_type': this.strategyParams.pt,
      'timeframe': interval.name,
      'start_time': this.strategyParams.entry_time,
      'end_time': this.strategyParams.exit_time,
    }
    data['settings']['days'] = data['settings']['days'] || []
    for (let key in this.strategyParams.days) {
      if (this.strategyParams.days[key]) {
        data['settings']['days'].push(key.toUpperCase())
      }
    }
    data['settings']['straddle_type'] = this.strategyParams.tt;
    let func;
    if (params.update) {
      func = this.threadService.update;
    } else {
      func = this.threadService.add;
    }
    func.apply(this.threadService, [data]).subscribe((response: any) => {
      if (response.response_code == 1000) {
        if (params.update) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Updated successfully");
        } else {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Added successfully");
        }
        this.dataService.strategyDetailsSaved({ success: true, thread: response.thread });
      } else {
        this.dataService.strategyDetailsSaved({ success: false });
      }
    });
  }

  is_strategy_params_valid() {
    let valid: any = this.strategyParams.lots.valid;
    valid = valid && this.strategyParams.time_valid;
    valid = valid && this.strategyParams.ss.valid.ce;
    valid = valid && this.strategyParams.ss.valid.pe;
    valid = valid && this.strategyParams.tgt.type_valid;
    valid = valid && this.strategyParams.tgt.value_valid;
    valid = valid && this.strategyParams.combined_tgt.type_valid;
    valid = valid && this.strategyParams.combined_tgt.value_valid;
    valid = valid && this.strategyParams.sl.type_valid;
    valid = valid && this.strategyParams.sl.value_valid;
    valid = valid && this.strategyParams.combined_sl.type_valid;
    valid = valid && this.strategyParams.combined_sl.value_valid;
    valid = valid && this.strategyParams.tsl.type_valid;
    valid = valid && this.strategyParams.tsl.value_valid;
    valid = valid && this.strategyParams.tsl.range_valid;
    valid = valid && this.strategyParams.tsl.sl_range_valid;
    return valid;
  }

  ngOnDestroy(): void {
      if (this.saveSettingsEvent) {
        this.saveSettingsEvent.unsubscribe();
      }
  }
}
